import {environment } from '../../environments/environment';

export const convertUrl= (oldUrl) => {
  const baseUrl = environment.wp_file_url;
  const urlParts = new URL(oldUrl);
  const newPath = urlParts.pathname + urlParts.search;

  return baseUrl + newPath;
}

export const getTagJSON = (tags) => {
  const result = {};
  for (const tag of tags) {
    result[tag.id] = tag.name;
  }
  return result;
}
